import { LocationEntity } from "../../api/Locations";
import { RootState } from "../store";
import { LocationSlice } from "./types";

export const selectLocation = (state: RootState): LocationEntity =>
  state.location;
